module.exports = __webpack_public_path__ + "static/media/rimeria.6513f658.png";